import { render, staticRenderFns } from "./campaign-strategy-tpl-use.vue?vue&type=template&id=c97d5290&scoped=true&"
import script from "./campaign-strategy-tpl-use.vue?vue&type=script&lang=js&"
export * from "./campaign-strategy-tpl-use.vue?vue&type=script&lang=js&"
import style0 from "./campaign-strategy-tpl-use.vue?vue&type=style&index=0&id=c97d5290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97d5290",
  null
  
)

export default component.exports